export const getTranslations = t => {
  return {
    addToCart: t("kf.myList.details.page.addToCart"),
    addItemsToCart: t("kf.myList.details.page.addItemsToCart"),
    moreOptions: t("kf.myList.details.page.moreOptions"),
    close: t("kf.myList.details.page.close"),
    myListPageTitle: t("kf.mylist.page.title"),
    createdDate: t("kf.myList.page.created"),
    createList: t("kf.saveToList.create.header"),
    tablTitle: t("kf.account.label.lists"),
    tablTitleMedia: t("kf.account.label.media"),
    listPageEmptyText: t("kf.myList.page.emptyTxt"),
    bestSellers: t("kf.myList.page.bestSellers"),
    sortBy: t("kf.favorite.label.sort"),
    edit: t("kf.account.label.edit"),
    deleteList: t("kf.myList.page.deletList"),
    moveItems: t("kf.myList.page.details.moveItems"),
    deleteItems: t("kf.myList.page.details.deleteItems"),
    itemPrice: t("kf.list.table.itemPrice"),
    quantity: t("kf.list.table.cartQuantity"),
    total: t("kf.list.table.total"),
    item: t("kf.list.table.item"),
    items: t("kf.list.table.items"),
    featured: t("kf.plp.label.featured"),
    listTotal: t("kf.myList.page.details.listTotal"),
    browseMoreProducts: t("kf.myList.page.details.browseMoreProducts"),
    selectAll: t("kf.list.button.selectAll"),
    created: t("kf.myList.page.details.create.label"),
    backToTop: t("kf.plp.label.backToTop"),
    editList: t("kf.myList.page.details.editList"),
    viewList: t("kf.findstore.label.viewList"),
    shoupOurBestSeller: t("kf.myList.page.ourBestSellers"),
    shoupOurBestSellerListBtn: t("kf.myList.page.ourBestSellers.listPage"),
    lessStock: t("kf.list.details.lessStock"),
    outOfStock: t("kf.list.details.outOfStock"),
    quantityModelHeader: t("kf.list.details.quantity.header"),
    quantityModelSubHeader: t("kf.list.details.quantity.subHeader"),
    addAvailableItemsToCart: t("kf.list.details.quantity.addAllToCart"),
    loadMore: t("kf.myList.page.details.loadMore"),
    availColorCTA: t("kf.myList.details.page.availColorCTA"),
    discontinued: t("kf.myList.details.page.discontinued"),
    colorAndFinish: t("kf.myList.details.page.colorAndFinish"),
    title: t("kf.pdp.label.title"),
    percentOff: t("kf.cart.label.off"),
    cadRequiredProductTitle: t("kf.pdp.label.cadRequiredProductTitle"),
    requiredProductTitle: t("kf.pdp.label.requiredProductTitle"),
    cadRequiredProductDescription: t(
      "kf.pdp.label.cadRequiredProductDescription"
    ),
    requiredProductDescription: t("kf.pdp.label.requiredProductDescription"),
    productText: t("kf.pdp.label.productText"),
    includeTextCTA: t("kf.myList.details.page.addToCart"),
    colorOrFinish: t("kf.cart.label.colorFinish"),
    outOfStockErr: t("kf.pdp.label.reqItem.err.outOfStockErrMsg"),
    backInStock: t("kf.pdp.label.notifyMailCTA"),
    requiredItemsToInstall: t("kf.list.details.items.requiredToInstall"),
    requiredItemsToInstallToolTip: t("kf.list.details.requiredItemsToInstall"),
    shareList: t("kf.myList.details.page.shareList"),
    share: t("kf.myList.details.page.share"),
    Remove: t("kf.myList.details.page.Remove"),
  }
}
